"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArffiliateSource = void 0;
var ArffiliateSource;
(function (ArffiliateSource) {
    ArffiliateSource["AmazonMusic"] = "amazon-music";
})(ArffiliateSource = exports.ArffiliateSource || (exports.ArffiliateSource = {}));
//# sourceMappingURL=arffilate-source.js.map